export enum SituationCorrections {
  IN_TYPING = 'IN_TYPING',
  AUTHORIZED = 'AUTHORIZED',
  REJECTED = 'REJECTED',
}

export const CorrectionSituationColor = {
  [SituationCorrections.IN_TYPING]: 'gray',
  [SituationCorrections.AUTHORIZED]: 'green',
  [SituationCorrections.REJECTED]: 'red',
};

export const CorrectionSituationLabel = {
  [SituationCorrections.IN_TYPING]: 'Em digitação',
  [SituationCorrections.AUTHORIZED]: 'Autorizada',
  [SituationCorrections.REJECTED]: 'Rejeitada',
};

export interface CorrectionsRequest {
  description: string;
  eventDateTime?: string;
  invoiceId: number;
  cceId?: number;
}

export interface CorrectionsResponse {
  authorizationProtocol: string;
  description: string;
  eventDateTime: string;
  filePath: string;
  id: number;
  invoiceId: number;
  nfeKey: string;
  reason: string;
  sequenceNumber: number;
  status: SituationCorrections;
}
